module.exports = __webpack_public_path__ + "media/chef-f2a77f7a.jpg";